<div [ngClass]="isFranchisee?'card1Franchisee':'card1'">
    <div class="row breadcrumb">
        <div class="col-md-4 col-sm-4 col-4">
            <span class="b-left" (click)="back()">
                <mat-icon>keyboard_arrow_left</mat-icon>
                <span routerLink="/project/details">Daily Log</span>
            </span>
        </div>
        <div class="col-md-4 col-sm-4 col-12">
            <h4 class="heading1">Daily Log Details</h4>
        </div>
    </div>
    <div class="bids-container">
        <!-- <div class="row">
            <div class="col-md-6 col-sm-6 col-12">
                <div class="b-address">
                    <mat-icon> location_on</mat-icon>
                    <span>{{projectDetail.project_address}}</span>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-12">
                <div class="b-name">
                    <mat-icon>account_circle</mat-icon>
                    <span>{{projectDetail.name}}</span>
                </div>
            </div>
        </div> -->
        <div class="table-containe">
            <table mat-table [dataSource]="logDetail" class="full-width-table">
          
              <ng-container matColumnDef="log_title">
                <th mat-header-cell *matHeaderCellDef>Log  Title </th>
                <td mat-cell *matCellDef="let element"> {{element.log_title}} </td>
              </ng-container>
          
              <ng-container matColumnDef="log_description">
                <th mat-header-cell *matHeaderCellDef> Log Detail </th>
                <td mat-cell *matCellDef="let element"> {{element.log_description}} </td>
              </ng-container>
          
              
              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef> Created on </th>
                <td mat-cell *matCellDef="let element"> {{element.created_at | date}} </td>
              </ng-container>
          
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element"> 
                      <span (click)="redirectOnView(element)" matTooltip="View">
                        <mat-icon class="custom-width-view">remove_red_eye</mat-icon>
                      </span>
                </td>
              </ng-container>
          
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
          
        
        
    </div>
</div>